import * as React from 'react';

import { withExceptionCatcher } from '@/components/hoc/with-exception-catcher';
import NewsletterIssuePageLayout from '@/components/pages/newsletter/issue/layout/newsletter-issue-page-layout';
import { PostType } from '@/types/events-custom-fields';

export interface NewsletterDailyPageControllerProps {
    issue: any;
    recentArticle: PostType | null;
}

export const NewsletterIssuePageController = (props: NewsletterDailyPageControllerProps) => {
    if (!props.issue) {
        // eslint-disable-next-line no-console
        console.error('Issue not found.');
        return null;
    }

    return <NewsletterIssuePageLayout issue={props.issue} recentArticle={props.recentArticle} />;
};

export default withExceptionCatcher(NewsletterIssuePageController);
